







































import { Component, Vue } from 'vue-property-decorator';
import { getIdFromUrl, Youtube } from 'vue-youtube';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import ArrowLinkUp from '@/components/icons/ArrowLinkUp.vue';

import { EOnlineInStoreStepSlug } from '../OnlineInStoreModal.vue';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    FilledButton,
    Youtube,
    ArrowLinkUp
  }
})
export default class Introduction extends Vue {
  $refs!: {
    youtube: HTMLFormElement;
  };

  watched = false;
  link: string = 'https://youtu.be/CRUEgOv6iZ8';

  get videoId() {
    return getIdFromUrl(this.link);
  }

  get youtubePlayer() {
    if (!this.$refs.youtube) return {};
    return this.$refs.youtube.player;
  }

  onPlaying() {
    if (!this.watched)
      segmentIo.track('Playing Activate Physical_Online Rewards Video');
    this.watched = true;
  }

  learnMoreClick() {
    segmentIo.track('Clicked Support Link Physical_Online Rewards', {
      Origin: 'Existing Merchant Modal'
    });
  }

  onStart() {
    this.$emit('goToStep', {
      redirectToSlug: EOnlineInStoreStepSlug.CONFIRMATION
    });
  }
}
